/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const slider = () => {
		if(document.querySelectorAll('.top-slider01').length) {
			const topslider01 = new Swiper('.top-slider01', {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 6000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.top-slider01-control .swiper-pagination',
					clickable: true,
				},
				on: {
				// 切り替わりのアニメーションが開始されたとき
				slideChangeTransitionStart: function() {
					if(document.querySelectorAll('.top-slider01-video').length) {
						if(topslider01.realIndex == 0) {
							document.querySelector('.top-slider01-video').currentTime=0;
						}
					}
				  },
				// スライドの切り替わりアニメーションが終了した時に実行
				  slideChangeTransitionEnd: function() {
					if(document.querySelectorAll('.top-slider01-video').length) {
						if(topslider01.realIndex == 0) {
							document.querySelector('.top-slider01-video').play();
						}
					}
				  },
				}
			});
			document.querySelector('.top-slider01-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider01.autoplay.start();
					if(document.querySelectorAll('.top-slider01-video').length) {
						document.querySelector('.top-slider01-video').currentTime=0;
						document.querySelector('.top-slider01-video').play();
					}
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider01.autoplay.stop();
					if(document.querySelectorAll('.top-slider01-video').length) {
						document.querySelector('.top-slider01-video').pause();
					}
				}
			});
		}
		if(document.querySelectorAll('.top-slider02').length) {
			if(!(document.querySelectorAll('.top-slider02-item').length == 1)) {
				document.querySelector('.top-slider02-control').classList.remove('di_none');
			}
			new Swiper('.top-slider02', {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				// pagination: {
				// 	el: '.swiper-pagination',
				// 	clickable: true,
				// },
				navigation: {
					nextEl: '.top-slider02-control .swiper-button-next',
					prevEl: '.top-slider02-control .swiper-button-prev',
				},
			});
		}
		if(document.querySelectorAll('.top-slider04').length) {
			new Swiper('.top-slider04', {
				slidesPerView: 1,
				spaceBetween: 0,
				// loop: true,
				// loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.top-slider04-control .swiper-button-next',
					prevEl: '.top-slider04-control .swiper-button-prev',
				},
				breakpoints: {
				  1024: {
					slidesPerView: 3,
					spaceBetween: 10,
				  },
				},
			});
		}
		if(document.querySelectorAll('.top-slider04_02').length) {
			new Swiper('.top-slider04_02', {
				slidesPerView: 1,
				spaceBetween: 0,
				// loop: true,
				// loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.top-slider04_02-control .swiper-button-next',
					prevEl: '.top-slider04_02-control .swiper-button-prev',
				},
				breakpoints: {
				  1024: {
					slidesPerView: 3,
				  },
				},
			});
			setTimeout(() => { 
				const $elements = document.querySelectorAll( '[data-mh]' );
				const groups = new Map();
	
				$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
	
				$elements.forEach( ele => {
					const attributeName = ele.getAttribute( 'data-mh' );
					if ( !groups.has( attributeName ) ) {
						groups.set( attributeName, [] );
					}
					groups.get( attributeName ).push( ele );
				} );
				groups.forEach( group => {
					const attributeGroups = new Map();
					group.forEach( ele => {
						const attributeName = ele.getAttribute( 'data-mh' );
						const topPosition = ele.getBoundingClientRect().top;
						const key = attributeName + '_' + topPosition;
						if ( !attributeGroups.has( key ) ) {
							attributeGroups.set( key, [] );
						}
						attributeGroups.get( key ).push( ele );
					} );
					attributeGroups.forEach( (item) => {
						const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
						item.forEach( (ele2) => {
							ele2.style.height = `${maxHeight}px`;
						});
					});
				} );
			 }, 300);
		}
	};

	slider();


})(window.FUNCTIONS);
